import React from "react";
import { Alert } from "antd";

export default props => {
  return (
    <Alert
      type="info"
      showIcon={true}
      message={
        <span>
          {"Access restricted. "}
          <a href="//www.unifiedpatents.com/join/" target="_new">
            {"Please upgrade your membership to gain full access."}
          </a>
        </span>
      }
      style={props.style}
    />
  );
};
